<!-- <app-header-one></app-header-one> -->
<app-header-latest></app-header-latest>

<div class="row">
    <div class="col-lg-4"></div>
    <div class="col-lg-5">
        <mat-tab-group>
            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon> account_circle</mat-icon>
                    Vendor
                </ng-template>
                <section class="login-page section-b-space">
                    <div class="container">
                        <div class="custom-form">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="theme-card">
                                        <!-- <h2>Vendor Login</h2> -->
                                        <div class="row">
                                            <div class="col-lg-12">&nbsp;</div>
                                        </div>
                                        <form [formGroup]="adminLoginForm" (ngSubmit)="onSubmit()">

                                            <mat-radio-group class="custom-radio" formControlName="role">
                                                <mat-radio-button value="VENDOR">Vendor</mat-radio-button>
                                                <mat-radio-button value="VENDOR_EMP">Employee</mat-radio-button>
                                            </mat-radio-group>
                                            <mat-error
                                                *ngIf="adminLoginForm.get('role').hasError('required') && adminLoginForm.get('role').touched">
                                                Please select Vendor or Employee
                                            </mat-error>

                                            <div class="row">
                                                <div class="col-lg-12">&nbsp;</div>
                                            </div>

                                            <div class="form-group form-group-change">
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Email</mat-label>
                                                    <input matInput type="email" id="email" formControlName="email"
                                                        placeholder="eg: johndoe@gmail.com">
                                                    <mat-error
                                                        *ngIf="adminLoginForm.get('email').hasError('required')">This
                                                        field is required</mat-error>
                                                </mat-form-field>
                                            </div>

                                            <div class="form-group form-group-custom">
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Password</mat-label>
                                                    <input matInput placeholder="eg: Password@123"
                                                        [type]="vendorPasswordhide ? 'password' : 'text'"
                                                        formControlName="password" required>
                                                    <mat-icon matSuffix
                                                        (click)="vendorPasswordhide = !vendorPasswordhide">{{vendorPasswordhide
                                                        ? 'visibility_off'
                                                        : 'visibility'}}</mat-icon>
                                                    <mat-error
                                                        *ngIf="form.get('password').hasError('required')">Password is
                                                        required.</mat-error>
                                                </mat-form-field>
                                            </div>
                                            <div style="display: flex; width: 100%;">
                                                <div style="width: 80%;margin-top: 4%; cursor: pointer;">
                                                    New member?
                                                    <a class="primary-color" (click)="goTo('/register')"

                                                        class="forgot-password-link " style="color: var(--primary-color);">Sign Up

                                                    </a>
                                                </div>

                                                <div style="width: 20%;">
                                                    <button type="submit" class="btn btn-solid _button">Login</button>
                                                </div>

                                            </div>
                                            <div style="margin-top: 4%; cursor: pointer;">
                                                <a class="primary-color" (click)="onForgotPasswordClick()"
                                                    class="forgot-password-link " style="color: var(--primary-color);">Forgot
                                                    Password?</a>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </mat-tab>

            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class="example-tab-icon">account_circle</mat-icon>
                    Interviewer
                </ng-template>
                <section class="login-page section-b-space">
                    <div class="container">
                        <div class="custom-form">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="theme-card">
                                        <h2>Interviewer Login</h2>
                                        <form [formGroup]="form">
                                            <div class="form-group form-group-change">
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Email</mat-label>
                                                    <input matInput type="email" id="email" formControlName="email"
                                                        placeholder="eg: johndoe@gmail.com">
                                                    <mat-error *ngIf="form.get('email').hasError('required')">This field
                                                        is required</mat-error>
                                                </mat-form-field>
                                            </div>

                                            <div class="form-group form-group-custom">
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Password</mat-label>
                                                    <input matInput placeholder="eg: Password@123"
                                                        [type]="interviewerPasswordhide ? 'password' : 'text'"
                                                        formControlName="password" required>
                                                    <mat-icon matSuffix
                                                        (click)="interviewerPasswordhide = !interviewerPasswordhide">{{interviewerPasswordhide
                                                        ? 'visibility_off'
                                                        : 'visibility'}}</mat-icon>
                                                    <mat-error
                                                        *ngIf="form.get('password').hasError('required')">Password is
                                                        required.</mat-error>
                                                </mat-form-field>
                                            </div>
                                            <div style="display: flex; width: 100%;">

                                                <div style="width: 80%;margin-top: 4%;">
                                                    <a style="color: var(--primary-color);cursor: pointer;"
                                                        (click)="goTo('/interviewer/interviewer-forgot-password')"
                                                        class="forgot-password-link">Forgot Password?</a>
                                                </div>
                                                <div style="width: 20%;">
                                                    <button (click)="validateInterviewer()"
                                                        class="btn btn-solid _button">Login</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </mat-tab>

            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class="example-tab-icon">account_circle</mat-icon>
                    Agent
                </ng-template>
                <section class="login-page section-b-space">
                    <div class="container">
                        <div class="custom-form">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="theme-card">
                                        <h2>Agent Login</h2>
                                        <form [formGroup]="form">
                                            <div class="form-group form-group-change">
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Email</mat-label>
                                                    <input matInput type="email" id="email" formControlName="email"
                                                        placeholder="eg: johndoe@gmail.com">
                                                    <mat-error *ngIf="form.get('email').hasError('required')">This field
                                                        is required</mat-error>
                                                </mat-form-field>
                                            </div>

                                            <div class="form-group form-group-custom">
                                                <mat-form-field appearance="outline">
                                                    <mat-label>Password</mat-label>
                                                    <input matInput placeholder="eg: Password@123"
                                                        [type]="interviewerPasswordhide ? 'password' : 'text'"
                                                        formControlName="password" required>
                                                    <mat-icon matSuffix
                                                        (click)="interviewerPasswordhide = !interviewerPasswordhide">{{interviewerPasswordhide
                                                        ? 'visibility_off'
                                                        : 'visibility'}}</mat-icon>
                                                    <mat-error
                                                        *ngIf="form.get('password').hasError('required')">Password is
                                                        required.</mat-error>
                                                </mat-form-field>
                                            </div>
                                            <div style="display: flex; width: 100%;">

                                                <div style="width: 80%;margin-top: 4%;">
                                                    <a style="color: var(--primary-color);cursor: pointer;" class="forgot-password-link" (click)="goTo('/register')">Sign Up</a>
                                                </div>

                                                <div style="width: 80%;margin-top: 4%;">
                                                    <a style="color: var(--primary-color);cursor: pointer;"
                                                        (click)="goTo('admin/agent-forgot-password')"
                                                        class="forgot-password-link">Forgot Password?</a>
                                                </div>
                                                <div style="width: 20%;">
                                                    <button (click)="validateAgent()"
                                                        class="btn btn-solid _button">Login</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </mat-tab>
        </mat-tab-group>
    </div>
    <div class="col-lg-3"></div>
</div>


<!-- <app-footer-one></app-footer-one> -->
<div class="gray-bg py-0">
    <app-our-apps></app-our-apps>
</div>
<!-- <app-footer-more-info></app-footer-more-info> -->
<app-peopleflow-footer></app-peopleflow-footer>